import { MaterializeAction } from 'angular2-materialize';
import { DomSanitizer } from '@angular/platform-browser';
import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    OnInit,
    OnChanges,
    SimpleChanges,
    AfterViewInit,
    OnDestroy,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from "../shared/helper-components/modal/_services/modal.service";
import { ModalPromptService } from '../shared/helper-components/modal-prompt.service';
import { ISubscription } from "rxjs/Subscription";
import { AppService } from '../app.service';
import { ClearanceItemImageService } from './clearance-item-image.service';
import { ClearanceItemService } from './clearance-item.service';
import { AppUtils, SharedUtils } from '../shared/utils';
import { CIAsset, CIImage, ClearanceItem } from './clearance-item.model';
import { NotificationsService, Notification } from '../shared/helper-components';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import * as FileSaver from 'file-saver';
import { ILookup } from '../shared/lookup';
declare var $: any; 
@Component({
    selector: 'carousel',
    template: require('./carousel.component.html'),
    styles: [require('./carousel.component.css')],
})
export class CarouselComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() index: number = 0;
    @Input() images;
    @Input() projectId: string;
    @Input() showSpinner;
    @Input() loop : Boolean=true;
    @Input() hideReportDefaultIcons : Boolean;
    @Input() dataImages = [];
    @Input() preventRemoval;
    @Input() itemList: ClearanceItem[] = [];
    @Input() currentCiName: string;
    @Input() statusLookup: ILookup[] = [];
    @Input() currentCiStatus: string;
    @Input() projectDepartment: string;
    @Output() onSetDefault: EventEmitter<any> = new EventEmitter();
    @Output() onShowOnReport: EventEmitter<any> = new EventEmitter();
    @Output() onDownload: EventEmitter<any> = new EventEmitter();
    @Output() onRemoveAsset: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();
    @Output() onCIStatusChanged: EventEmitter<any> = new EventEmitter();
    @Output() onSaveDetails: EventEmitter<any> = new EventEmitter();


    @ViewChild('divImage') divImage: ElementRef;
    @ViewChild('divPanel') divPanel: ElementRef;
    @ViewChild('divContainer') divContainer: ElementRef;
    @ViewChild('imgFont') imgFont: ElementRef; 
    @ViewChild('imgUsage') imgUsage: ElementRef; 
    @ViewChild('imgNotes') imgNotes: ElementRef; 
    @ViewChild('divButtons') divButtons: ElementRef; 
    imageIsLoaded: Boolean = false;
    currentIndex: number=0;
    currentCiIndex: number=0;
    currentCiId: string;
    promptSubscription: ISubscription;
    currentFullImageUrl: string;
    currentImageName: string;
    currentFont: string;
    currentTag: string;
    currentUsage: string;
    currentNotes: string;
    transition: boolean = false;
    delayTime: number=0;
    panelVisible: boolean = false;
    enableActionButtons: boolean = false;
    fileIsImage: boolean = false;
    fileIsPDF: boolean = false;
    originalCiStatus: string;
    loadingCI: boolean = false;
    loadingImage: boolean = false;
    savingCI: boolean = false;

    private observer: MutationObserver;

    constructor(
        private modalService: ModalService,
        private _prompt: ModalPromptService,
        private _appService: AppService,
        private _clearanceItemImageService: ClearanceItemImageService,
        private _clearanceItemService: ClearanceItemService,
        private _notificationsService: NotificationsService,
        private _errorHandler: GlobalErrorHandler,
        private router: Router
    ) {
        this.modalService.subscribeToModalOpenClose().subscribe(action => {
            if (!action){
                this.imageIsLoaded = false;
            }
        });
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
          }
    }

    ngOnChanges(){
        this.currentIndex = this.index;
        this.imageIsLoaded = true;
        this.setCurrentImageUrl();
        this.setImageNotes();
        this.transition = false;
        this.originalCiStatus = this.currentCiStatus;
        this.changeStatus(this.currentCiStatus);
    }

    ngAfterViewInit() {
        $('#statusSelect').material_select();

        this.observer = new MutationObserver(() => {
            this.applySelectStatusStyles();
          });

        this.observer.observe(document.querySelector('.container-carousel'), {
            childList: true,
            subtree: true,
          });

        this.applySelectStatusStyles();
      }
    goToNext(): void {
        const isLastImage = this.currentIndex === this.images.length - 1;
        if (!isLastImage || this.loop)
        {
            const newIndex = isLastImage ? 0 : this.currentIndex + 1;
            this.currentIndex = newIndex;
        }
    }

    goToPrevious(): void {
        const isFirstImage = this.currentIndex === 0;
        if (!isFirstImage || this.loop)
        {
            const newIndex = isFirstImage ?  this.images.length - 1 : this.currentIndex - 1;
            this.currentIndex = newIndex;
        }
    }

    transitionDelay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    setCurrentImageUrl(): void {
        this.setImageNotes();
        this.transition = true;
        this.showSpinner = true;
        this.fileIsImage = SharedUtils.FileTypeIsImage(this.images[this.currentIndex].fileType);
        this.fileIsPDF = this.images[this.currentIndex].fileType.endsWith('pdf');
        if (!this.images[this.currentIndex].originalImageFullUrl && this.fileIsImage){
            this.images[this.currentIndex].originalImageFullUrl = this.getImageData(this.images[this.currentIndex].url);
        }
        if (this.currentFullImageUrl == this.images[this.currentIndex].originalImageFullUrl && this.fileIsImage){
            this.setImageLoaded();
            this.currentImageName = this.images[this.currentIndex].name;
            return;
        }
        this.currentFullImageUrl = null;
        this.currentImageName="";
        
        if (!this.images[this.currentIndex].originalImageFullUrl && (this.fileIsImage || this.fileIsPDF)){
            this.images[this.currentIndex].originalImageFullUrl = this.getImageData(this.images[this.currentIndex].url);
        }
        if (!this.images[this.currentIndex].originalImageFullUrl && (this.fileIsImage || this.fileIsPDF)){
            this._appService.getSignedUrl(this.images[this.currentIndex].url, this.projectId,'GET','image','ci',this.images[this.currentIndex].urlName)
            .subscribe((data) => {
                this.images[this.currentIndex].originalImageFullUrl = data.url;
                this.currentFullImageUrl = data.url;
                this.currentImageName = this.images[this.currentIndex].name;
            });
        }
        else{
            if (this.fileIsImage && this.images[this.currentIndex].originalImageFullUrl.startsWith('data:image')){
                this.delayTime = Math.ceil(this.images[this.currentIndex].originalImageFullUrl.length/2000000/10)*50;
            }
            if (this.images[this.currentIndex].fileType.endsWith('pdf')){
                this.currentFullImageUrl="../../assets/images/PDF_file_icon.png"
            }
            else if (!SharedUtils.FileTypeIsImage(this.images[this.currentIndex].fileType)){
                this.currentFullImageUrl="../../assets/images/attachment-icon.jpg"
                this.setImageLoaded();
            }
            else{
                this.currentFullImageUrl = this.images[this.currentIndex].originalImageFullUrl    
            }
            this.currentImageName = this.images[this.currentIndex].name;
            if (this.images[this.currentIndex].name.endsWith('.pdf')){
                this.setImageLoaded();
            }
        }   
    }

    setImageLoaded() {
        var parent = this;
        this.transitionDelay(this.delayTime).then(() => {
            parent.imageIsLoaded = true;
            parent.showSpinner = false;
            parent.transition = false;
        });
    }

    closeModal(id: string){
        this.imageIsLoaded = false;
        this.panelVisible = false
        this.setPanelVisible(this.currentIndex);
        if (this.modalService.modalExists('image-modal-carousel')){
            this.modalService.close(id);
        }
        this.onClose.emit(id);
    }

    setDefaultCurrentItem(event){
        let currentState = this.images[this.currentIndex].defaultC;
        this.images.forEach(image => {
            image.defaultC = false;
        });

        this.images[this.currentIndex].defaultC=!currentState;
        this.onSetDefault.emit(event.id);
    }

    showItemOnReport(event){
        let currentState = this.images[this.currentIndex].showOnReports;
        this.images[this.currentIndex].showOnReports=!currentState;
        this.onShowOnReport.emit(event.id);
    }

    saveImage(event){
        this.getDirectDownload(this.images[this.currentIndex])
     }

    removeImage(){
        this.promptSubscription = this._prompt.openModal(
            this.removeCurrentItem.bind(this), true).first().subscribe(r=>{
        });
    }

    removeCurrentItem(){
        let index = this.currentIndex;
        this.images.splice(index,1);
        if (this.images.length>0){
            this.currentIndex = index === 0 ? this.currentIndex : this.currentIndex - 1;
            this.setCurrentImageUrl();
        }
        else{
            this.closeModal('image-modal-carousel');
        }
        this.onRemoveAsset.emit(index);
    }

    openImage(){
        if (this.images[this.currentIndex].name.endsWith('.pdf')){
            window.open(this.images[this.currentIndex].originalImageFullUrl);
        }
        else{
            var template = AppUtils.openInNewTemplate();
            var imageWindow = window.open();
            var imageDocument = imageWindow.document.open();
            var deviceHeight =  window.innerHeight * 0.97;
            var deviceWidth =  window.innerWidth * 0.97;
            template = template
                        .replace('{{IMAGE_NAME}}',this.images[this.currentIndex].name)
                        .replace('{{IMAGE_SOURCE}}',this.images[this.currentIndex].originalImageFullUrl)
                        .replace('{{DEVICE_HEIGHT}}',deviceHeight.toString())
                        .replace('{{DEVICE_WIDTH}}',deviceWidth.toString());
            imageDocument.write(template);
            imageDocument.close();
        }
    }

    getImageData(url){
        var img = this.dataImages.find((data)=>{
            return data.name == url;
        });
        if (img){
            return img.imageData;
        }
    }

    openAnnotationTool(){
        this.imageIsLoaded = false;
        this.modalService.close('image-modal-carousel');
        this.router.navigate(['/docviewer', encodeURIComponent(this.images[this.currentIndex].url), this.images[this.currentIndex].name]);
    }

    stopPropagation(event: Event) {
        event.stopPropagation();
    }

    setPanelVisible(event){
        this.panelVisible = !this.panelVisible;

        const divContainer = this.divContainer.nativeElement;
        const divImage = this.divImage.nativeElement;
        const divPanel = this.divPanel.nativeElement;
        const divButtons = this.divButtons.nativeElement;
        
        divImage.style["transition-duration"] ="0s";
        if (this.panelVisible){
            divPanel.style["width"]="20%";
            divPanel.style["display"]="unset";
            divImage.style["width"]="80%";
        }
        else
        {
            divPanel.style["width"]="0%";
            divPanel.style["display"]="none";
            divImage.style["width"]="100%";
        }

        setTimeout(() => {
            const divImage = this.divImage.nativeElement;
            divImage.style["transition-duration"] = '2s';
          }, 0);
    }

    setImageNotes(){
        this.currentFont = this.images[this.currentIndex].font;
        this.currentUsage = this.images[this.currentIndex].usage;
        this.currentTag = this.images[this.currentIndex].tag;
        this.currentNotes = this.images[this.currentIndex].notes;
        this.enableActionButtons=false;
    }

    saveImageNotes(){
        this.savingCI = true;
        var ciImage: CIImage = this.images[this.currentIndex];

        ciImage.font = this.imgFont.nativeElement.value;
        ciImage.usage = this.imgUsage.nativeElement.value;
        ciImage.notes = this.imgNotes.nativeElement.value;

        this._clearanceItemImageService.patchImage(ciImage)
            .subscribe(img => {
                this.enableActionButtons=false;
                this._notificationsService.add(new Notification('success', 'Image details were updated successfully'));
                this.onSaveDetails.emit(ciImage);
                this.savingCI=false;
            },
        (error: any) => {
            var e = JSON.stringify(error);
            if(e.indexOf("AntiXssMiddleware") !== -1 || error.includes("AntiXssMiddleware")){
              this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));                     
            }else{
              this._errorHandler.processError(error);
            }
            this.savingCI=false;
            console.error(error);
        } );
    }

    undoImageNotes(){
        this.setImageNotes();
    }

    onAnyNotesChanged(event: Event){
        this.enableActionButtons=true;
    }

    onImageModalDivClick(event: Event) {
        event.stopPropagation();
      }

    getDirectDownload(item) {
        this.showSpinner = true;
        var projectId = item.url.split('/')[2];
        var ownerType = "ci";
        this._appService.getSignedUrl(encodeURIComponent(item.url), projectId, 'GET', 'image', ownerType, encodeURIComponent(item.name))
        .subscribe(signedUrl => {
            let downloadedAsset = Object.assign(new CIAsset(), item);
            downloadedAsset.fullUrl = signedUrl.url;
            downloadedAsset.name = item.name;
            console.log('ImageProcessing.downloadAsset >> signed Url:' + signedUrl.url);
            this.downloadAsset(downloadedAsset);
        });
    }

    downloadAsset(item) {
        this._appService.getFileAs(item).subscribe(f=>{
            FileSaver.saveAs(f, item.name);
            this.showSpinner = false;
        });
    }

    goToNextCI(): void {
        this.loadingCI = true;
        this.currentImageName = "";
        this.currentCiName = "";
        this.transition = true;
        this.showSpinner = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        this.currentCiIndex = this.itemList.findIndex(ci => ci.id == this.currentCiId); 
        this.currentCiIndex = (this.currentCiIndex + 1) % this.itemList.length;
        while (this.itemList[this.currentCiIndex].images.filter(i => i.assetType == "Image").length == 0){
            this.currentCiIndex = (this.currentCiIndex + 1) % this.itemList.length;
        }
        this.openCI(this.itemList[this.currentCiIndex]);
    }

    goToPreviousCI(): void {
        this.loadingCI = true;
        this.currentImageName = "";
        this.currentCiName = "";
        this.transition = true;
        this.showSpinner = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        this.currentCiIndex = this.itemList.findIndex(ci => ci.id == this.currentCiId); 
        this.currentCiIndex = (this.currentCiIndex - 1 + this.itemList.length) % this.itemList.length;
        while (this.itemList[this.currentCiIndex].images.filter(i => i.assetType == "Image").length == 0){
            this.currentCiIndex = (this.currentCiIndex - 1 + this.itemList.length) % this.itemList.length;
        }
        this.openCI(this.itemList[this.currentCiIndex]);
    }

    

    openCI(item: ClearanceItem){
        var parent = this;
        this._clearanceItemService.getCI(item.id, true)
            .subscribe
            (
                (data) => {
                    parent.onCIRetrieved(data);
                    var default_index = parent.images.findIndex(img => img.url == item.images[0].url);
                    parent.currentIndex = default_index;
                    this.setCurrentImageUrl();
                }
            )
    }

    onCIRetrieved(ci: ClearanceItem): void {
        if (ci) {
            this.images = [];
            this.currentIndex = 0;
            this.showSpinner=false;
            this.currentCiName = ci.name;
            this.originalCiStatus = ci.status;
            this.loadingCI = false;
            this.changeStatus(ci.status);
            var ciImages = ci.images;

            if (ciImages && ciImages.length > 0){
                ciImages.forEach(img => {
                    if (img.assetType=="Image"){
                        img.originalImageFullUrl = img.fullUrl;
                        this.images.push(img);
                    }    
                });
            }
        }
    }

    undoStatusChange(){
        this.changeStatus(this.originalCiStatus);
    }

    saveStatusChange(){
        this.showSpinner  = true;
        this.savingCI = true;
        this.currentCiId = this.images[this.currentIndex].cIId;
        this.ciStatusChange({ciId: this.currentCiId, ciStatus: this.currentCiStatus});
    }
    updateMaterializeSelect() {
        this.changeStatus(this.currentCiStatus);
      }

    changeStatus(newStatus: string){
        this.currentCiStatus = newStatus;
    }

    ciStatusChange($event){
        let itemToSave = this.itemList.find(ci => ci.id == $event.ciId)
        itemToSave.status = $event.ciStatus;

            this._clearanceItemService.saveClearanceItemStatus(itemToSave)
            .subscribe(ci => {
                this.onClearanceItemSaved(ci);
            },
                err => {
                    this.savingCI = false;
                    var e = JSON.stringify(err);

                    if(e.indexOf("AntiXssMiddleware") !== -1 || err.includes("AntiXssMiddleware")){
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));
                        this.showSpinner = false;
                    }
                    else{
                        this.showSpinner = false;
                        this._errorHandler.processError(err);
                    }
                });
    }

    onClearanceItemSaved(ci: ClearanceItem) {
        this.showSpinner  = false;
        this.savingCI = false;
        if (ci && ci.id) {
            this._notificationsService.add(new Notification('success', 'Clearance Item saved successfully.'));
            this.currentCiStatus = ci.status;
            this.originalCiStatus = ci.status;
            this.onCIStatusChanged.emit({ciId: this.currentCiId, ciStatus: this.currentCiStatus})
        }
        else {
            this._notificationsService.add(new Notification('error', 'Failed to save Clearance Item, Please try again later.'));
        }
    }

    private applySelectStatusStyles() {
        $('.container-carousel .select-wrapper').css('color', 'white');
        $('.container-carousel .select-wrapper .caret').css('color', 'white');
      }

}       


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/carousel.component.ts